import * as React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText  from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useNavigate,useLocation } from 'react-router-dom';
import { mainColor } from '../../constants';
export const MainListItems =()=>{
    const location=useLocation()
    const navigate=useNavigate();
    const [active,setAtive]=React.useState(location.pathname)
    const handleClick=(text)=>{
        navigate(text)
        setAtive(text)
    }
    return(
      <React.Fragment>
        <ListItemButton  onClick={()=>handleClick('/')} >
          <ListItemIcon sx={{color:active=="/"?mainColor:"white"}}>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText sx={{color:active==="/"?mainColor:"white"}} primary="Dashboard" />
        </ListItemButton>
        <ListItemButton onClick={()=>handleClick('/merchants')}>
          <ListItemIcon sx={{color:active=="/merchants"?mainColor:"white"}}>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText sx={{color:active==="/merchants"?mainColor:"white"}} primary="Stores" />
        </ListItemButton>
        <ListItemButton onClick={()=>handleClick('/admins')} >
          <ListItemIcon sx={{color:active=="/admins"?mainColor:"white"}}>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText sx={{color:active==="/admins"?mainColor:"white"}} primary="Admins" />
        </ListItemButton>
       <ListItemButton onClick={()=>handleClick('/plans')} >
          <ListItemIcon sx={{color:active=="/plans"?mainColor:"white"}}>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText sx={{color:active==="/plans"?mainColor:"white"}} primary="Plans" />
        </ListItemButton>
        
      </React.Fragment>
    );

} 

export const secondaryListItems = ""
// null&&(
//   <React.Fragment>
//     <ListSubheader component="div" inset>
//       Saved reports
//     </ListSubheader>
//     <ListItemButton>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText sx={{color:active==="/"?mainColor:"white"}} primary="Current month" />
//     </ListItemButton>
//     <ListItemButton>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText sx={{color:active==="/"?mainColor:"white"}} primary="Last quarter" />
//     </ListItemButton>
//     <ListItemButton>
//       <ListItemIcon>
//         <AssignmentIcon />
//       </ListItemIcon>
//       <ListItemText sx={{color:active==="/"?mainColor:"white"}} primary="Year-end sale" />
//     </ListItemButton>
//   </React.Fragment>
// );